import Vue from "vue";
import moment from "moment";
import { i18n } from "../main";

Vue.filter("formatDate", function (value) {
  if (moment(value).isValid()) {
    return moment(value).format("DD/MM/YYYY");
  }
  return "";
});

Vue.filter("formatDateHour", function (value) {
  if (moment(value).isValid()) {
    return moment(value).format("DD/MM/YYYY HH:mm");
  }
  return "";
});

Vue.filter("tableStatusColor", function (value) {
  switch (value) {
    case "ok":
    case "low":
      return "green";
    case "expired_audit":
    case "expired_review":
    case "control_not_tested":
    case "pending_revision":
    case "risk_asset":
    case "medium":
      return "#FFA000";
    case "missing_evidence":
    case "refected":
    case "no_risk_definition":
    case "high":
      return "red";
    default:
      return "#17a2b8";
  }
});

Vue.filter("tableStatusIdToColor", function (value) {
  switch (value) {
    case "ok":
    case 1:
      return "green";
    case 2:
      return "blue";
    case 3:
      return "rgb(105 115 116)";
    case 4:
      return "#FFA000";
    case 5:
      return "red";
  }
});

Vue.filter("tableStatusIdToText", function (value) {
  switch (value) {
    case "ok":
    case 1:
      return "Muito Baixa";
    case 2:
      return "Baixa";
    case 3:
      return "Média";
    case 4:
      return "Alta";
    case 5:
      return "Muito Alta";
  }
});

Vue.filter("statusText", function (value) {
  switch (value) {
    case "ok":
      return "OK";
    case "expired_audit":
      return "Auditoria Expirada";
    case "missing_evidence":
      return "Falta evidência";
    case "refected":
      return "Rejeitado";
    case "expired_review":
      return "Revisão expirada";
    case "control_not_tested":
      return "Controle não testado";
    case "pending_revision":
      return "Revisão de Risco Pendente";
    case "no_risk_definition":
      return "Sem definição de risco";
    case "risk_asset":
      return "Ativo com risco";
    case "low":
      return "BAIXO";
    case "medium":
      return "MÉDIO";
    case "high":
      return "ALTO";
    default:
      return "";
  }
});

Vue.filter("phoneMask", function (v) {
  if (!v) return "";
  var r = v.replace(/\D/g, "");
  if (r.length < 10) return v;
  var dd = r.substr(0, 2);
  var n1 = "";
  var n2 = "";
  if (r.length == 10) {
    n1 = r.substr(2, 4);
    n2 = r.substr(6, r.length);
  } else {
    n1 = r.substr(2, 5);
    n2 = r.substr(7, r.length);
  }
  return "(" + dd + ") " + n1 + " - " + n2;
});

Vue.filter("toBr", function (str) {
  if (!str) return "";
  return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
});

Vue.filter("formatDeletedUser", function (value) {
  return value === "user_deleted" ? i18n.t("comuns.deletedUser") : value;
});

